import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { fetchRepositorios, createRepositorio } from '../../api/repositorios';
import './Repositorios.css';

function formatarData(d) {
    if (!d) return '—';
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return '—';
    return dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const FILTROS = [
    { key: 'todos', label: 'Todos' },
    { key: 'manual', label: 'Manuais' },
    { key: 'sprint', label: 'De sprint' }
];

function RepositoriosHome() {
    const history = useHistory();
    const [repos, setRepos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtro, setFiltro] = useState('todos');
    const [busca, setBusca] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [novoNome, setNovoNome] = useState('');
    const [novoDescricao, setNovoDescricao] = useState('');

    const verificar = useCallback(async () => {
        const ok = await verificandoApp('ATENDENTE');
        if (!ok) history.push('/');
    }, [history]);

    const carregar = useCallback(async () => {
        verificandoToken();
        setLoading(true);
        try {
            const list = await fetchRepositorios();
            setRepos(Array.isArray(list) ? list : []);
        } catch (e) {
            setRepos([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        verificar();
        carregar();
    }, [verificar, carregar]);

    const criar = async () => {
        verificandoToken();
        const nome = (novoNome || '').trim();
        if (!nome) { setMensagem('Informe o nome do repositório.'); return; }
        try {
            const res = await createRepositorio({ nome, descricao: novoDescricao || null });
            setShowModal(false);
            setNovoNome('');
            setNovoDescricao('');
            setMensagem('');
            const novoId = res?.data?.id;
            if (novoId) history.push(`/repositorios/${novoId}`);
            else carregar();
        } catch (e) {
            setMensagem(e?.response?.data?.error || 'Erro ao criar repositório.');
        }
    };

    const filtrados = repos
        .filter((r) => (filtro === 'todos' ? true : r.tipo === filtro))
        .filter((r) => {
            const q = busca.trim().toLowerCase();
            if (!q) return true;
            return String(r.nome || '').toLowerCase().includes(q) || String(r.descricao || '').toLowerCase().includes(q);
        });

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado repo-page">
                    <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                        <div>
                            <h1 className="mb-0"><i className="fas fa-code-branch me-2" />Repositórios</h1>
                            <p className="text-muted small mb-0">Versionamento de arquivos com histórico e recuperação.</p>
                        </div>
                        <button type="button" className="btn btn-primary btn-sm" onClick={() => { setMensagem(''); setShowModal(true); }}>
                            <i className="fas fa-plus me-1" />Novo repositório
                        </button>
                    </div>

                    {mensagem && !showModal && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}

                    <div className="repo-toolbar d-flex flex-wrap align-items-center gap-2 mb-3">
                        <div className="repo-filtros">
                            {FILTROS.map((f) => (
                                <button key={f.key} type="button"
                                    className={`btn btn-sm ${filtro === f.key ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => setFiltro(f.key)}>{f.label}</button>
                            ))}
                        </div>
                        <div className="repo-busca-wrap input-group input-group-sm">
                            <span className="input-group-text" aria-hidden="true"><i className="fas fa-search" /></span>
                            <input
                                type="search"
                                className="form-control repo-busca"
                                placeholder="Buscar por nome ou descrição…"
                                value={busca}
                                onChange={(e) => setBusca(e.target.value)}
                                aria-label="Buscar repositórios"
                            />
                            {busca.trim() && (
                                <button type="button" className="btn btn-outline-secondary" onClick={() => setBusca('')} title="Limpar busca">
                                    <i className="fas fa-times" />
                                </button>
                            )}
                        </div>
                        {busca.trim() && !loading && (
                            <span className="small text-muted">{filtrados.length} de {repos.length} repositório(s)</span>
                        )}
                    </div>

                    {loading && <p className="text-muted">Carregando repositórios...</p>}

                    {!loading && filtrados.length === 0 && (
                        <div className="alert alert-info py-3">
                            {repos.length === 0
                                ? 'Nenhum repositório ainda. Crie o primeiro (ex.: "Senior ERP").'
                                : 'Nenhum repositório no filtro/busca atual.'}
                        </div>
                    )}

                    {!loading && filtrados.length > 0 && (
                        <div className="row g-3">
                            {filtrados.map((r) => (
                                <div key={r.id} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                                    <div className="card repo-card h-100" role="button" tabIndex={0}
                                        onClick={() => history.push(`/repositorios/${r.id}`)}
                                        onKeyDown={(e) => e.key === 'Enter' && history.push(`/repositorios/${r.id}`)}>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h5 className="card-title mb-0 repo-card-titulo">
                                                    <i className={`fas ${r.tipo === 'sprint' ? 'fa-tasks' : 'fa-folder'} me-2`} />
                                                    {r.nome}
                                                </h5>
                                                <span className={`badge ${r.tipo === 'sprint' ? 'bg-info' : 'bg-secondary'}`}>
                                                    {r.tipo === 'sprint' ? 'Sprint' : 'Manual'}
                                                </span>
                                            </div>
                                            {r.descricao && <p className="card-text text-muted small mb-2 repo-card-desc">{r.descricao}</p>}
                                            <div className="repo-card-metricas d-flex gap-3 flex-wrap">
                                                <span className="repo-metrica"><i className="fas fa-file me-1" />{r.total_arquivos ?? 0} arquivo(s)</span>
                                                <span className="repo-metrica"><i className="fas fa-clock me-1" />{formatarData(r.ultimo_commit_em || r.criado_em)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </main>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                        <h5 className="mb-3">Novo repositório</h5>
                        <div className="form-group mb-2">
                            <label>Nome</label>
                            <input value={novoNome} onChange={(e) => setNovoNome(e.target.value)} className="form-control form-control-sm" placeholder="Ex.: Senior ERP" autoFocus />
                        </div>
                        <div className="form-group mb-2">
                            <label>Descrição (opcional)</label>
                            <textarea value={novoDescricao} onChange={(e) => setNovoDescricao(e.target.value)} className="form-control form-control-sm" rows={2} placeholder="Para que serve este repositório" />
                        </div>
                        {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                        <div className="d-flex justify-content-end gap-2">
                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancelar</button>
                            <button type="button" className="btn btn-primary btn-sm" onClick={criar}>Criar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default RepositoriosHome;
